import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()

export class LessonsService {

  constructor(private http: HttpClient) {}

}
